var map = {
	"./box.png": "./src/eazy-docs/assets/images/widgets/box.png",
	"./boxed_tabbed_docs.png": "./src/eazy-docs/assets/images/widgets/boxed_tabbed_docs.png",
	"./collaborative_docs.png": "./src/eazy-docs/assets/images/widgets/collaborative_docs.png",
	"./creative.png": "./src/eazy-docs/assets/images/widgets/creative.png",
	"./docbox.png": "./src/eazy-docs/assets/images/widgets/docbox.png",
	"./flat_tabbed_docs.png": "./src/eazy-docs/assets/images/widgets/flat_tabbed_docs.png",
	"./light.png": "./src/eazy-docs/assets/images/widgets/light.png",
	"./tabbed_doc_list.png": "./src/eazy-docs/assets/images/widgets/tabbed_doc_list.png",
	"./topicsbox.png": "./src/eazy-docs/assets/images/widgets/topicsbox.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/eazy-docs/assets/images/widgets sync \\.(png%7Cjpg%7Cjpeg%7Cgif%7Csvg)$";